module.exports = __webpack_public_path__ + "f1590bdd20ef6cf78bba2a857d914026.svg";